import { render, staticRenderFns } from "./MaterialsInfoUpload.vue?vue&type=template&id=0571bef8&scoped=true&"
import script from "./MaterialsInfoUpload.vue?vue&type=script&lang=js&"
export * from "./MaterialsInfoUpload.vue?vue&type=script&lang=js&"
import style0 from "./MaterialsInfoUpload.vue?vue&type=style&index=0&id=0571bef8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0571bef8",
  null
  
)

export default component.exports